import { render, staticRenderFns } from "./SmileMessageElement.vue?vue&type=template&id=21873354&scoped=true&"
import script from "./SmileMessageElement.vue?vue&type=script&lang=babel&"
export * from "./SmileMessageElement.vue?vue&type=script&lang=babel&"
import style0 from "./SmileMessageElement.vue?vue&type=style&index=0&id=21873354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21873354",
  null
  
)

export default component.exports